module.exports = __webpack_public_path__ + "img/yardages-dark-green.0b2ae175.svg";